import { render, staticRenderFns } from "./QPerformDashBtn.vue?vue&type=template&id=9a947680&scoped=true&"
import script from "./QPerformDashBtn.vue?vue&type=script&lang=js&"
export * from "./QPerformDashBtn.vue?vue&type=script&lang=js&"
import style0 from "./QPerformDashBtn.vue?vue&type=style&index=0&id=9a947680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a947680",
  null
  
)

export default component.exports